export const TAGS_LIMIT = 2;
